import React from 'react';
import { Box } from '@mui/material';

// Layout components matching polotno's PolotnoContainer / SidePanelWrap / WorkspaceWrap
export function DesignContainer({ children, style, ...props }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        ...style,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}

// Alias for polotno compat
export const PolotnoContainer = DesignContainer;

export function SidePanelWrap({ children, style, ...props }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexShrink: 0,
        height: '100%',
        overflow: 'visible',
        ...style,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}

export function WorkspaceWrap({ children, style, ...props }) {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        ...style,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}

// Re-export store
export { createStore, Store } from './model/store';

// Re-export side panel
export {
  SidePanel,
  DEFAULT_SECTIONS,
  SectionTab,
  ImagesGrid,
  TextSection,
  BackgroundSection,
  LayersSection,
  ElementsSection,
  UploadSection,
  InputFieldsSection,
} from './side-panel/index';

// Re-export toolbar
export { Toolbar } from './toolbar/toolbar';
export { ZoomButtons } from './toolbar/zoom-buttons';

// Re-export workspace
export { Workspace } from './canvas/workspace';

// Re-export config
export { setTranslations, getTranslations, t, setTheme, getTheme, setInputFieldsConfig, getInputFieldsConfig } from './config';

// Re-export utils
export { unitToPx, pxToUnit } from './utils/unit';
export { getImageSize, loadImage, cropImage } from './utils/image';
export { fetchGoogleFonts, loadGoogleFont, DEFAULT_FONTS } from './utils/fonts';

// Re-export components
export { InputFieldsDialog } from './components/InputFieldsDialog';
